// 前端配置文件
// 修改 API_URL 指向 Go 后端地址
const config = {
  // Go 后端 API 地址
  API_URL: process.env.REACT_APP_API_URL || 'https://api.zeipo.com/thsapi',
};

export default config;
